import { useCallback } from 'react';

import { useEchoNavigate } from './useEchoNavigate';

import { type SubmitOptions, submit } from '../client/request';
import { disableForm, endSubmit, getFormAction, getFormMethod, startSubmit } from '../dom/form';

import type { EchoState, SetEchoState } from './useEchoState';
import type { EchoSubmitFn } from '../types';

async function performSubmission(options: SubmitOptions): Promise<EchoState> {
  try {
    return { status: 'ok', echo: await submit(options), isPreview: false };
  } catch (error) {
    return { status: 'error', error };
  }
}

export function useEchoSubmit(setState: SetEchoState): EchoSubmitFn {
  const echoNavigate = useEchoNavigate();

  return useCallback(
    async (form, submitter) => {
      const method = getFormMethod(form, submitter);
      const action = getFormAction(form, submitter);
      const url = new URL(action, window.location.href);
      const body = new FormData(form, submitter);

      startSubmit(form, { method, url });
      disableForm(form);
      const result = await performSubmission({ method, action, body });

      if (result.status === 'error') {
        setState(result);
        endSubmit(form, { method, url, status: null });
      } else if (result.echo.type === 'navigation') {
        await echoNavigate(result.echo);
        endSubmit(form, { method, url, status: 204 });
      } else {
        setState(result);
        endSubmit(form, { method, url, status: result.echo.status });
      }
    },
    [setState, echoNavigate]
  );
}
